import * as R from 'ramda'
import * as RA from 'ramda-adjunct'

/**
 * 接收一个函数和两个对象，遍历第一个对象的key, 优先进行函数处理，如果没有处理，判断第二个对象有key，则拷贝向第一个对象
 *
 * @func
 * @memberOf R_
 * @category Object
 * @param {Function} fn 要调用的函数，接收三个参数: `key`, `l`, `r`.
 * @param {object} l 源对象
 * @param {object} r 要对其附值的对象
 * @return {object} 已附值的对象
 */
const updateWithObjCustom = R.curry((fn, l, r) => {
  const copyObj = R.clone(l)
  const syncFunc = (key) => {
    if (Object.prototype.hasOwnProperty.call(r, key)) {
      let val = R.prop(key)(r)
      if (RA.isBoolean(copyObj[key])) {
        if (RA.isBoolean(val)) {
          copyObj[key] = val
        } else if (RA.isString(val)) {
          val = (val === 'true' || (!R.isEmpty(val) && val !== '0' && val !== 'false'))
        } else if (RA.isInteger(val)) {
          val = val !== 0
        } else {
          val = false
        }
      } else if (RA.isInteger(copyObj[key])) {
        val = Number.parseInt(val || 0)
      } else if (RA.isString(copyObj[key])) {
        val = String(val || '')
      } else if (RA.isArray(copyObj[key])) {
        if (RA.isNilOrEmpty(val)) {
          val = []
        } else {
          if (copyObj[key].length) {
            if (RA.isString(copyObj[key][0])) {
              val = val.map(it => String(it ?? ''))
            } else if (RA.isInteger(copyObj[key][0])) {
              val = val.map(it => Number(it ?? 0))
            } else {
              val = [val]
            }
          } else {
            val = [val]
          }
        }
      }
      copyObj[key] = val
    }
  }

  R.forEachObjIndexed((value, key) => {
    if (fn) {
      if (!fn(key, copyObj, r)) {
        syncFunc(key)
      }
    } else {
      syncFunc(key)
    }
  })(l)
  return copyObj
})

/**
 * 接收两个对象，遍历第一个对象的key, 如果第二个对象有key，则拷贝互第一个对象
 *
 * @func
 * @memberOf R_
 * @category Object
 * @param {object} l 源对象
 * @param {object} r 要对其附值的对象
 * @return {object} 已附值的对象
 */
const updateWithObj = R.curry((l, r) => updateWithObjCustom(null, l, r))

/**
 * 接收两个参数，第一参数，表示转换数字失败时返回的数字，第二个参数表示要转换的数字
 *
 * @func
 * @memberOf R_
 * @category Object
 * @param {int} defaultVal 表示转换数字失败时返回的数字
 * @param {int} val 表示要转换的数字
 * @return {int} 转换的结果
 */
const parseInteger = R.curry((defaultVal, val) => {
  if (R.isNil(val)) {
    return defaultVal
  }
  const reg = /^\s*-?\d+$\s*/
  if (reg.test(val)) {
    return Number.parseInt(val)
  }
  return defaultVal
})
/**
 * 是否为为价格
 */
const isPrice = R.curry((val) => {
  const reg = /^(([1-9]\d*)|\d)(\.\d{0,2})?$/
  return reg.test(val)
})

const swapArray = R.curry((index1, index2, array) => {
  const t = array[index1]
  array[index1] = array[index2]
  array[index2] = t
  return array
})

const R_ = {
  updateWithObjCustom,
  updateWithObj,
  parseInteger,
  isPrice,
  swapArray,
}

export default R_
